import axios from "axios";
const jsonConfig = require("../../Config.json");

const getUserTestDynamicQuestion = async (userId, testid) => {
  let allResponse = {};
  try {
    const getallresponse = await axios.get(
      jsonConfig.apiUrl + "newtestquestionsdynamic/" + userId + "/" + jsonConfig.userIndustryId + "/" + testid + "/dynamic",
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    allResponse = getallresponse;

    return Promise.resolve(allResponse);
  }
  catch (error) {
    console.log("errrrrr", error);
    return Promise.reject(error);
  }
}

export default getUserTestDynamicQuestion;